import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Modal, Button } from "react-bootstrap";
import { API_BASE_URL } from "../../config/serverApiConfig";
import * as apiService from "../../services";
import "./LoginPage.css"; // Custom CSS for the login page
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const AdminLogin = () => {
  const [data, setData] = useState({ user: "", password: "" });
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [email, setNewEmail] = useState("");
  const [changePasswordMsg, setChangePasswordMsg] = useState("");
  const navigate = useNavigate();

  // Hide the register button (if any) on mount
  useEffect(() => {
    const registerButton = document.getElementById("reg");
    if (registerButton) {
      registerButton.style.display = "none";
    }
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const url = API_BASE_URL + "/sbuserlogin";
      const { data: res } = await axios.post(url, data);

      // If login fails (user_login is false), display the error message
      if (res.user_login === false) {
        setError(res.Message || "User or Password Incorrect");
        return;
      }

      // If login is successful but admin status is false, show error message
      if (res.Admin_Status === false) {
        setError("You are not an admin. Try company login.");
        return;
      }

      // If admin status is true, store user data and redirect to /admin
      window.localStorage.setItem("token", res.user_data[0].admincode);
      window.localStorage.setItem("user_data", JSON.stringify(res.user_data[0]));
      window.localStorage.setItem("adminid", res.user_data[0].adminid);
      window.localStorage.setItem("admin_type", res.user_data[0].admin_type);
      window.localStorage.setItem("adminemail", res.user_data[0].adminemail);
      window.location = "/admin";
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      } else {
        setError("An unexpected error occurred.");
      }
    }
  };

  const handleCloseChangePassword = () => {
    setShowChangePassword(false);
  };

  const handleChangePassword = () => {
    setShowChangePassword(true);
  };

  const handlePasswordChange = async () => {
    try {
      const response = await apiService.forgetPassword(email);
      console.log(response);
      setChangePasswordMsg(response.Message);

      const sendmail = `<body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0">
        <div class="container" style="width:70%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,0.2);border-radius:8px;text-align:center">
          <div class="header" style="margin-bottom:20px">
            <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Company Logo" style="width:auto;height:100px;">
          </div>
          <div class="content" style="text-align:left;line-height:1.6">
            <h4 style="margin-top:0">Your Password Reset Information</h4>
            <p style="font-size:16px;">Dear ${response.name},</p>
            <p style="font-size:16px;">Your password for Star Behaviors has been reset as requested today. Below are your new login details:
              <b><br>Username:</b> ${response.email},<br><b>Password:</b> ${response.tempPassword}
            </p>
            <p style="font-size:16px;">Please log in to your Star Behaviors account using the following link:</p>
            <p style="font-size:16px;"><a href="https://sb.starbehaviors.com/" style="color:#06c;text-decoration:none">Star Behaviors Login</a></p>
            <p style="font-size:16px;">If you did not initiate this password reset request, please contact our support team immediately at <a href="mailto:support@starbehaviour.com" style="color:#06c;text-decoration:none">support@starbehaviour.com</a>.</p>
            <p style="font-size:16px;">Thank you for choosing Star Behaviors!<br>Best regards,</p>
          </div>
          <div class="footer" style="margin-top:20px;font-size:0.9em;color:#555">Star Behaviors Support</div>
        </div>
      </body>`;

      const payload = {
        email: email,
        name: response.name,
        subject: "Your Password Reset Information",
        message: sendmail,
      };

      const mailResponse = await fetch("https://bakemywords.com/mailchimp/sendmail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        mode: "no-cors"
      });
      const result = await mailResponse.json();
      console.log(result);
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  return (
    <>
      <div style={{ background: '#EFEFEF', paddingLeft: '35px', paddingTop: '15px', color: '#0088FF' }}>
        <a onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}><MdOutlineKeyboardArrowLeft size={20} /> Back</a>
      </div>
      <div className="sb-login-page-container">
        <div className="sb-login-card">
          <h4 className="sb-login-card-header text-uppercase">Admin Login</h4>
          <div className="sb-login-card-body">
            {showChangePassword && (
              <Modal
                show={showChangePassword}
                onHide={handleCloseChangePassword}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Forgot Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <label>Email</label>
                  <br />
                  <input
                    className="form-control"
                    placeholder="Enter Your Email"
                    type="email"
                    value={email}
                    onChange={(e) => setNewEmail(e.target.value)}
                  />
                  <span style={{ color: "red" }}>{changePasswordMsg}</span>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseChangePassword}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handlePasswordChange}>
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
            <form onSubmit={handleSubmit} className="sb-login-form">
              <div className="form-floating mb-3 sb-login-form-floating">
                <input
                  id="emailAddress"
                  className="form-control sb-login-input"
                  type="email"
                  name="user"
                  onChange={handleChange}
                  value={data.user}
                  required
                  placeholder="Email Address"
                />
                <label htmlFor="emailAddress" className="sb-login-label">
                  Email Address
                </label>
              </div>
              <div className="input-group mb-3">
                <div className="form-floating flex-fill sb-login-form-floating">
                  <input
                    id="password"
                    className="form-control sb-login-input"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={handleChange}
                    value={data.password}
                    required
                    placeholder="Password"
                  />
                  <label htmlFor="password" className="sb-login-label">
                    Password
                  </label>
                </div>
                <button
                  className="btn btn-outline-secondary sb-login-toggle-btn"
                  type="button"
                  onClick={handleTogglePasswordVisibility}
                >
                  <Icon icon={showPassword ? "oi:eye" : "oi:eye"} />
                </button>
              </div>
              {error && <div className="sb-login-error">{error}</div>}
              <div className="sb-login-btn-group">
                <button type="submit" className="sb-login-btn">
                  Login
                </button>
                <button
                  className="sb-login-btn-secondary"
                  type="button"
                  onClick={handleChangePassword}
                >
                  Forgot Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
